'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Menu;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Menu() {
  return _react2.default.createElement(
    'nav',
    { className: 'Menu' },
    _react2.default.createElement(
      'ul',
      null,
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          { href: '#' },
          '\xC0 propos'
        )
      ),
      _react2.default.createElement(
        'li',
        { className: 'current' },
        _react2.default.createElement(
          _reactRouter.IndexLink,
          { to: '/' },
          '\xC9v\xE8nements'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          { href: '#' },
          'Membres'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          { href: '#' },
          'Lab d\u2019innovation sociale'
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu.js
// module id = 1146
// module chunks = 0